var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('router-view'),_c('v-overlay',{attrs:{"value":_vm.showLoading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }